import useRequest from '@/shared/composables/use-request';
import type { FeedbackPayload } from './../types';

class Feedback {
	async sendFeedback(payload: FeedbackPayload) {
		return await useRequest().$post('/other/feedback/', {
			body: payload,
		});
	}
}

export default new Feedback();
